import { createRouter, createWebHashHistory } from 'vue-router'
import AdminLayout from '../components/admin/AdminLayout.vue'

// Uygulama router'ı - hash mode kullanarak sunucu tarafı F5 yenileme hatalarını engeller
const router = createRouter({
  // createWebHashHistory: URL'lere # ekleyerek (örn: /#/panel/rewards) tüm istekleri tek bir
  // dosyaya (index.html) yönlendirir; böylece sunucu ekstra rewrite ayarı gerektirmez.
  history: createWebHashHistory(),
  routes: [
    {
      path: '/',
      redirect: '/panel/rewards',
    },
    // Login sayfası geçici olarak devre dışı
    // {
    //   path: '/panel/login',
    //   name: 'admin-login',
    //   component: () => import('../views/admin/LoginView.vue'),
    // },
    {
      path: '/panel',
      component: AdminLayout,
      // meta: { requiresAuth: true }, // Geçici olarak auth kontrolü kaldırıldı
      children: [
        {
          path: '',
          redirect: '/panel/rewards',
        },
        {
          path: 'rewards',
          name: 'admin-rewards',
          component: () => import('../views/admin/RewardsView.vue'),
        },
        {
          path: 'transferred',
          name: 'admin-transferred',
          component: () => import('../views/admin/TransferredView.vue'),
        },
      ],
    },
  ],
})

// Route guard - Admin sayfalarına erişim kontrolü
// Geçici olarak login kontrolü devre dışı
router.beforeEach((to, from, next) => {
  // Login sayfası geçici olarak kaldırıldı, auth kontrolü yok
  next()
  
  // Eski kod (ileride tekrar aktif edilebilir):
  // const token = localStorage.getItem('admin_token')
  // const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  // 
  // if (requiresAuth && !token) {
  //   next('/panel/login')
  // } else if (to.path === '/panel/login' && token) {
  //   next('/panel')
  // } else {
  //   next()
  // }
})

export default router
